module.exports = __webpack_public_path__ + "static/media/KNET.a591e152.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/PaymentModes/KNET.svg
// module id = 904
// module chunks = 0